import { Directive } from '@angular/core';

@Directive({
  selector: '[xpo-view-mgt-full-width]',
  host: { class: 'xpo-ViewMgt-FullWidth' },
})
export class XpoViewMgtFullWidthDirective {}
